import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

// import { PhnxFormselect } from './Formselect'
// import { FormselectProps } from './Formselect'

interface FormselectBlokProps {
  blok: {
    // title: FormselectProps['title']
  } & SbBlokData
}

const Formselect: FC<FormselectBlokProps> = ({ blok }) => {
  return <div {...storyblokEditable(blok)}>{/* <PhnxFormselect title={blok.title} /> */}</div>
}

export default Formselect
